import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppInfo } from '../models/app-info.model';
import { ApiService } from './api.service';
import { PaginatedResponse } from '../models/paginated-response.model';
import { User } from '../models/user.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root' // 👈 makes it a singleton global service
})
export class AppService {


  private editModeSubject = new BehaviorSubject<boolean>(false);
  private isEditorSubject = new BehaviorSubject<boolean>(false);
  private isAdminSubject = new BehaviorSubject<boolean>(false);
  editMode$: Observable<boolean> = this.editModeSubject.asObservable();
  editor$: Observable<boolean> = this.isEditorSubject.asObservable();
  admin$: Observable<boolean> = this.isAdminSubject.asObservable();

  appInfo!: AppInfo;

  constructor(private apiService: ApiService) {}

  enableEditMode() {
    this.editModeSubject.next(true);
  }

  disableEditMode() {
    this.editModeSubject.next(false);
  }

  setAdmin(isEditor: boolean) {
    this.isAdminSubject.next(isEditor);
  }

  setEditor(isEditor: boolean) {
    this.isEditorSubject.next(isEditor);
  }

  getAppInfo(){
    return this.apiService.get("api/app-info/")
  }

  toggleEditMode() {
    this.editModeSubject.next(!this.editModeSubject.value);
  }

  isEditMode(): boolean {
    return this.editModeSubject.value;
  }

  getUsers(params?: { page?: number; page_size?: number; search?: string }): Observable<PaginatedResponse<User>> {
    return this.apiService.get<PaginatedResponse<User>>('api/users/', params, true);
  }

  getUsersList(params?: { page?: number; page_size?: number; search?: string }): Observable<User[]> {
    return this.getUsers(params).pipe(map(res => res.results ?? []));
  }
}
